import React from "react";

function WhatIsAMM() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>What is AMM DEX?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  An AMM DEX (Automated Market Maker Decentralized Exchange) is
                  a type of decentralized exchange that uses algorithms to
                  facilitate trading between assets without relying on
                  traditional order books. Instead of matching buy and sell
                  orders between users, AMM DEXs employ liquidity pools and
                  automated pricing algorithms to allow users to trade directly
                  against pooled liquidity.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhatIsAMM;
